import { useContext } from 'react'
import { useFormikContext } from 'formik'

import { EmailFormContext } from '../../EmailForm.context'
import { EmailPreviewModal } from '../../EmailPreviewModal'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_SELECTED_TEMPLATE,
  EMAIL_CREATION_FORM_FIELD_NAME_SIGNATURE,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
} from '../EmailCreationForm.constants'
import { getEmailFormPreviewValues } from '../EmailCreationForm.utils'

export function useEmailPreview({
  files,
  getPreviewDependencies,
  linkedFiles,
  templateEntityApiParams,
  withFromField,
  onDeleteAttachment,
  onSend,
}) {
  const { setFieldValue, values } = useFormikContext()

  const signature = values[EMAIL_CREATION_FORM_FIELD_NAME_SIGNATURE]

  const formContext = useContext(EmailFormContext)

  function handleChangeRecipients(recipients) {
    setFieldValue(EMAIL_CREATION_FORM_FIELD_NAME_TO, recipients)
  }

  function handleSendFromPreview(e) {
    onSend(e)
    formContext.onCloseModal()
  }

  function handlePreview() {
    formContext.setModal(
      <EmailPreviewModal
        getPreviewDependencies={getPreviewDependencies}
        linkedFiles={linkedFiles}
        templateEntityApiParams={templateEntityApiParams}
        textTemplate={values[EMAIL_CREATION_FORM_FIELD_NAME_SELECTED_TEMPLATE]}
        values={getEmailFormPreviewValues({
          files,
          signature,
          values,
        })}
        withFromField={withFromField}
        onClose={formContext.onCloseModal}
        onDeleteAttachment={onDeleteAttachment}
        onDeleteRecipient={handleChangeRecipients}
        onSend={handleSendFromPreview}
      />
    )
  }

  return {
    handlePreview,
  }
}
